import i18n from 'src/typescript/servicos/i18n/i18n.servico'

const OPCOES_DE_TIPO_DE_ACUMULO_AGRUPADO_DA_BAIXA_DE_BH = [
  {id: 'horas_extras', name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeAcumulo.horasExtras')},
  {id: 'horas_extras_extraordinarias', name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeAcumulo.horasExtrasExtraordinarias')},
  {id: 'horas_extras_especiais', name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeAcumulo.horasExtrasEspeciais')}
]

const OPCOES_DE_SOBREAVISO_POR_TIPO_DE_ACUMULO = {
  horas_extras: {
    id: 'horas_extras_de_sobreaviso',
    name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeAcumulo.horasExtrasDeSobreavisos')
  },
  horas_extras_extraordinarias: {
    id: 'horas_extras_extraordinarias_de_sobreaviso',
    name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeAcumulo.horasExtrasExtraordinariasDeSobreavisos')
  },
  horas_extras_especiais: {
    id: 'horas_extras_especiais_de_sobreaviso',
    name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeAcumulo.horasExtrasEspeciaisDeSobreavisos')
  }
}

export const OPCOES_DE_TIPO_DE_ACUMULO_DA_BAIXA_DE_BH = OPCOES_DE_TIPO_DE_ACUMULO_AGRUPADO_DA_BAIXA_DE_BH

export const OPCOES_DE_TIPO_DE_ACUMULO_COM_SOBREAVISO_DA_BAIXA_DE_BH =
  OPCOES_DE_TIPO_DE_ACUMULO_AGRUPADO_DA_BAIXA_DE_BH.flatMap(opcao => [
    opcao,
    OPCOES_DE_SOBREAVISO_POR_TIPO_DE_ACUMULO[opcao.id]
  ])

export const OPCOES_DE_TIPO_DE_COMPENSACAO_DA_BAIXA_DE_BH = [
  {id: 'atrasos', name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeCompensacao.atrasos')},
  {id: 'saidas_antecipadas', name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeCompensacao.saidasAntecipadas')},
  {id: 'pausas_em_excesso', name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeCompensacao.pausasEmExcesso')},
  {id: 'horas_de_falta', name: i18n.t('hourBankRules.details.state.CompensacaoEmOrdem.opcoesDeCompensacao.horasDeFalta')}
]

export function obterOpcoesDeTipoDeAcumuloDaBaixaDeBh (separarHorasExtrasDeSobreaviso) {
  return separarHorasExtrasDeSobreaviso
    ? OPCOES_DE_TIPO_DE_ACUMULO_COM_SOBREAVISO_DA_BAIXA_DE_BH
    : OPCOES_DE_TIPO_DE_ACUMULO_DA_BAIXA_DE_BH
}

/**
 * Normaliza a ordem dos acumulos apos alterar a separacao do sobreaviso.
 * Preserva a ordem das categorias normais validas, remove duplicadas e
 * invalidas, completa categorias ausentes e intercala cada categoria de
 * sobreaviso com sua categoria correspondente quando a separacao esta ativa.
 *
 * @param {Array<{id: string, name: string}>} criterios Criterios selecionados.
 * @param {boolean} separarHorasExtrasDeSobreaviso Se deve separar o sobreaviso.
 * @returns {Array<{id: string, name: string}>} Criterios normalizados.
 */
export function normalizarOrdemDeAcumulosAoAlterarSeparacao (criterios, separarHorasExtrasDeSobreaviso) {
  const idsSelecionados = new Set((criterios || []).map(criterio => criterio.id))
  const idsNormaisAdicionados = new Set()
  const opcoesNormaisOrdenadas = (criterios || [])
    .filter(criterio => {
      const ehOpcaoNormal = OPCOES_DE_TIPO_DE_ACUMULO_AGRUPADO_DA_BAIXA_DE_BH.some(opcao => opcao.id === criterio.id)
      if (!ehOpcaoNormal || idsNormaisAdicionados.has(criterio.id)) return false

      idsNormaisAdicionados.add(criterio.id)
      return true
    })

  OPCOES_DE_TIPO_DE_ACUMULO_AGRUPADO_DA_BAIXA_DE_BH.forEach(opcao => {
    if (!idsSelecionados.has(opcao.id)) opcoesNormaisOrdenadas.push(opcao)
  })

  if (!separarHorasExtrasDeSobreaviso) return opcoesNormaisOrdenadas

  return opcoesNormaisOrdenadas.flatMap(opcao => [
    opcao,
    OPCOES_DE_SOBREAVISO_POR_TIPO_DE_ACUMULO[opcao.id]
  ])
}

function validarOrdem (criterios, opcoesEsperadas) {
  const idsEsperados = new Set(opcoesEsperadas.map(opcao => opcao.id))
  const idsRecebidos = (criterios || []).map(criterio => criterio?.id)
  const idsRecebidosUnicos = new Set(idsRecebidos)

  const faltantes = opcoesEsperadas.filter(opcao => !idsRecebidosUnicos.has(opcao.id))
  const invalidas = [...idsRecebidosUnicos].filter(id => !idsEsperados.has(id))
  const duplicadas = idsRecebidos.filter((id, indice) => idsRecebidos.indexOf(id) !== indice)

  return {
    valida: idsRecebidos.length === opcoesEsperadas.length &&
      faltantes.length === 0 &&
      invalidas.length === 0 &&
      duplicadas.length === 0,
    faltantes,
    invalidas,
    duplicadas: [...new Set(duplicadas)]
  }
}

export function validarOrdemDeAcumulos (criterios, separarHorasExtrasDeSobreaviso) {
  return validarOrdem(
    criterios,
    obterOpcoesDeTipoDeAcumuloDaBaixaDeBh(separarHorasExtrasDeSobreaviso)
  )
}

export function validarOrdemDeCompensacoes (criterios) {
  return validarOrdem(criterios, OPCOES_DE_TIPO_DE_COMPENSACAO_DA_BAIXA_DE_BH)
}

export function obterCriteriosSelecionados (criterios, opcoes, { preservarInvalidos = false } = {}) {
  if (!criterios) return []

  return criterios
    .map(id => opcoes.find(opcao => opcao.id === id) || (preservarInvalidos ? {id, name: String(id)} : undefined))
    .filter(Boolean)
}
